import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { authService } from "../../app/services/authService";

const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: "https://collive.supabase.co/functions/v1/classified-api/stripe",
  prepareHeaders: async (headers) => {
    const session = await authService.getCurrentUser();

    if (session) {
      headers.set("Authorization", `Bearer ${session.access_token}`);
    }

    headers.set("Content-Type", "application/json");

    return headers;
  },
});

export default baseQueryWithAuth;
